import React from 'react';
import { motion } from 'framer-motion';
export function CostOfInaction() {
  const costs = [{
    sin: 'Noches sin dormir bien × 365 días',
    real: 'Tu energía, tu humor y tu rendimiento al 60%'
  }, {
    sin: 'Cafeína para funcionar todos los días',
    real: 'Ciclo de dependencia que empeora el sueño'
  }, {
    sin: 'Suplementos comprados al azar sin sistema',
    real: 'Plata tirada sin resultados medibles'
  }, {
    sin: 'Productividad reducida por niebla mental',
    real: 'Decisiones lentas, creatividad baja, más errores'
  }, {
    sin: 'Estrés que no baja porque no recuperás',
    real: 'Cortisol alto crónico que retroalimenta el insomnio'
  }, {
    sin: 'Relaciones afectadas por el mal humor',
    real: 'El cansancio crónico no es solo tuyo — lo pagán todos'
  }, {
    sin: 'El próximo año exactamente igual',
    real: 'El mismo ciclo, las mismas noches, el mismo agotamiento'
  }];
  return <section className="py-24 relative bg-slate-900/80 border-y border-white/5" data-id="element-26">
      <div className="container mx-auto px-4" data-id="element-27">
        <div className="text-center mb-16" data-id="element-28">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-white flex items-center justify-center gap-3" data-id="element-29">
            <span aria-hidden="true" data-id="element-30">⚖️</span> ¿CUÁNTO CUESTA NO TENERLO?
          </h2>
        </div>

        <div className="max-w-4xl mx-auto mb-16" data-id="element-31">
          <div className="md:hidden text-center text-sm text-slate-500 mb-4 flex items-center justify-center gap-2" data-id="element-32">
            ← Scroll to see full table →
          </div>
          <div className="overflow-x-auto hide-scrollbar rounded-2xl border border-white/10 bg-slate-800/20" data-id="element-33">
            <table className="w-full min-w-[600px] text-left border-collapse" data-id="element-34">
              <thead data-id="element-35">
                <tr className="border-b border-white/10 bg-slate-800/50" data-id="element-36">
                  <th className="p-5 font-semibold text-slate-400 w-1/2" data-id="element-37">
                    Sin Megapack
                  </th>
                  <th className="p-5 font-semibold text-red-400 w-1/2" data-id="element-38">
                    Costo real
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-white/5" data-id="element-39">
                {costs.map((row, i) => <tr key={i} className="hover:bg-slate-800/30 transition-colors" data-id="element-40">
                    <td className="p-5 text-slate-300 text-sm" data-id="element-41">{row.sin}</td>
                    <td className="p-5 text-red-300/80 text-sm font-medium" data-id="element-42">
                      {row.real}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-43">
          <p className="text-3xl md:text-5xl font-display font-bold text-amber-500 italic" data-id="element-44">
            Esta noche puede ser diferente.
          </p>
        </motion.div>
      </div>
    </section>;
}